import { render, staticRenderFns } from "./ESecaoFormulario.vue?vue&type=template&id=604f8ec2"
import script from "./ESecaoFormulario.vue?vue&type=script&lang=js"
export * from "./ESecaoFormulario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports